<sai-header></sai-header>
<ng-container *saiHasRight="'CAN_READ_DATA'">
    <router-outlet></router-outlet>
</ng-container>
<sai-loading></sai-loading>
